import React from 'react';
import { Outlet, useLocation } from 'react-router';
import classNames from 'classnames';
import Sidebar from 'Components/Sidebar';
import useIsMobile from 'Hooks/Common/useIsMobile';

const SidebarSubLayout = () => {
  const isMobile = useIsMobile();
  const location = useLocation();

  return (
    <div className={classNames('main-layout__content', { mobile: isMobile })}>
      {!isMobile && (
        <div className="main-layout__sidebar">
          <Sidebar location={location} />
        </div>
      )}
      <div className="main-layout__container">
        <Outlet />
      </div>
    </div>
  );
};

export default SidebarSubLayout;
